<template>
    <div style="padding-bottom: 70px;">
        <Query ref="queryRef" :reload="reload" @query-click="handleQueryClick" @updata="handleUpdata"
            :tags="tagsActive" />
        <div v-loading="loading">
            <ObliqueTags ref="obliqueTagsRef" :tags="tags" v-model="tagsActive" @tab-click="handleTabClick" />
            <div class="bg-white pt10 pl10 pr10 pb10 borderRadius5 order_table_no_border">
                <div class="operation-box mb10" ref="operationRef">
                    <div class="operation-left">

                        <template v-if="tagsActive == 1">
                            <el-button type="primary" size="mini" v-if="getCurAuth('add_work_order')"
                                @click="toCreatePage"
                                v-matomo="{ behaviorCategory: '素材工单(工单管理-待指派)', event: '点击', name: '创建工单' }">创建工单</el-button>
                        </template>
                        <template v-else-if="tagsActive == 2">
                            <el-button type="primary" size="mini" v-if="getCurAuth('add_work_order')"
                                v-matomo="{ behaviorCategory: '素材工单(工单管理-制作中)', event: '点击', name: '创建工单' }"
                                @click="toCreatePage">创建工单</el-button>
                            <el-button type="primary" size="mini" v-if="getCurAuth('batch_download_material')" plain
                                v-matomo="{ behaviorCategory: '素材工单(工单管理-制作中)', event: '点击', name: '批量下载素材' }"
                                @click="handleFilterDown">批量下载素材</el-button>
                            <el-button type="primary" size="mini" v-if="getCurAuth('completion_work_order')" plain
                                       v-matomo="{behaviorCategory: '素材工单(工单管理-制作中)', event: '点击',  name: '批量下载素材' }"
                                       @click="batchSettle">批量结单</el-button>
                        </template>
                        <template v-else-if="tagsActive == 3">
                            <el-button type="primary" size="mini" v-if="getCurAuth('add_work_order')"
                                v-matomo="{ behaviorCategory: '素材工单(工单管理-被驳回)', event: '点击', name: '创建工单' }"
                                @click="toCreatePage">创建工单</el-button>
                        </template>
                        <template v-else-if="tagsActive == 4">
                            <el-button type="primary" size="mini" v-if="getCurAuth('add_work_order')"
                                v-matomo="{ behaviorCategory: '素材工单(工单管理-已完成)', event: '点击', name: '创建工单' }"
                                @click="toCreatePage">创建工单</el-button>
                            <el-button type="primary" size="mini" v-if="getCurAuth('batch_download_material')" plain
                                v-matomo="{ behaviorCategory: '素材工单(工单管理-已完成)', event: '点击', name: '批量下载素材' }"
                                @click="handleFilterDown">批量下载素材</el-button>
                        </template>
                        <template v-else-if="tagsActive == 5">
                            <el-button type="primary" size="mini" v-if="getCurAuth('add_work_order')"
                                v-matomo="{ behaviorCategory: '素材工单(工单管理-已撤回)', event: '点击', name: '创建工单' }"
                                @click="toCreatePage">创建工单</el-button>
                        </template>
                        <template v-else-if="tagsActive == 6">
                            <el-button type="primary" size="mini" v-if="getCurAuth('add_work_order')"
                                       v-matomo="{behaviorCategory: '素材工单(工单管理-待结单)', event: '点击',  name: '创建工单' }"
                                       @click="toCreatePage">创建工单</el-button>
                            <el-button type="primary" size="mini" v-if="getCurAuth('batch_download_material')" plain
                                       v-matomo="{behaviorCategory: '素材工单(工单管理-待结单)', event: '点击',  name: '批量下载素材' }"
                                       @click="handleFilterDown">批量下载素材</el-button>
                            <el-button type="primary" size="mini" v-if="getCurAuth('completion_work_order')" plain
                                       v-matomo="{behaviorCategory: '素材工单(工单管理-待结单)', event: '点击',  name: '批量下载素材' }"
                                       @click="batchSettle">批量结单</el-button>
                        </template>
                        <el-button 
                            type="primary" 
                            size="mini" 
                            v-if="getCurAuth('work_order_label_edit')" plain
                            v-matomo="{behaviorCategory: '素材工单', event: '点击',  name: '修改工单标签' }"
                            @click="handleTagEdit(multipleSelection)"
                        >
                            修改工单标签
                        </el-button>
                    </div>
                    <div class="operation-right">
                        <el-button icon="el-icon-s-operation" size="mini" @click="handleFieldTable">自定义列</el-button>
                        <el-button icon="el-icon-download" size="mini" :loading="exportLoading"
                            @click="exportData">导出</el-button>
                    </div>
                </div>
                <jt-table :data="tableData" style="width: 100%" 
                    :header-cell-style="{ background: '#e8eaec', color: '#333' }" size="mini"
                    @sort-change="handlesortchange" @selection-change="handleSelectionChange" @header-dragend="handleDragEnd"
                    header-cell-class-name="header-cell" class="setSortHeight" border stripe ref="refs_table">
                    <!-- 默认 v-if="tagsActive == 2 || tagsActive == 4||tagsActive == 6"-->
                    <el-table-column type="selection" width="55"  >
                    </el-table-column>
                    <el-table-column :prop="column.id" :label="column.display_name" :width="getLocalStorageWidth[column.id] || column.width"
                        :fixed="column.fixed != '' ? column.fixed : false" :sortable="getsortable(column.id)"
                        v-for="(column, index) in columns" :key="index">
                        <template slot="header" slot-scope="scope">
                            <el-tooltip effect="dark" placement="top" v-if="column.id=='company_name'||column.id=='bloc_name'">
                                <span>{{column.display_name}} <i class="el-icon-question"></i></span>
                                <div slot="content">
                                    <div v-if="column.id=='company_name'">
                                        <p>客户名称取值逻辑：</p>
                                        <p>1、如果有消耗：取选择的项目创建时近30天有消耗的账户对应的客户。</p>
                                        <p>2、如果无消耗：取选择的项目在聚投绑定的客户。</p>
                                    </div>
                                    <div v-else>
                                        <p>集团名称取值逻辑：</p>
                                        <p>1、如果有消耗：取选择的项目创建时近30天有消耗的账户对应的客户对应的集团。</p>
                                        <p>2、如果无消耗：取选择的项目在聚投绑定的客户对应的集团。</p>
                                    </div>
                                </div>
                            </el-tooltip>
                            <span v-else-if="column.id=='special_content'" class="text-color-error">{{column.display_name}}</span>
                            <span v-else>{{column.display_name}}</span>
                        </template>
                        <template slot-scope="scope">
                            <div v-if="column.id == 'urgent_level_text'">
                                <span v-if="scope.row['urgent_level'] == 2" style="color: #ff0000;"
                                    @dblclick="copyText(scope.row[column.id])">{{ scope.row[column.id] }}</span>
                                <span v-else @dblclick="copyText(scope.row[column.id])">{{ scope.row[column.id]
                                    }}</span>
                            </div>
                            
                            <div v-else-if="column.id == 'expected_end_time'"
                                @dblclick="copyText(`${scope.row['expected_end_time']}`)">
                                <span :style="{color: formatDateColor(scope.row['expected_end_time'])}">{{ scope.row['expected_end_time'] }}</span>
                            </div>
                            <div v-else-if="column.id == 'pass_material_num'"
                                @dblclick="copyText(`${scope.row['pass_material_num']}/${scope.row['material_num']}`)">
                                <span style="color: #409EFF;padding-right: 5px;">{{ scope.row['pass_material_num']
                                    }}</span>/
                                <span>{{ scope.row['material_num'] }}</span>
                            </div>
                            <div v-else-if="column.id == 'work_order_label'" >
                                <div class="tab-box">
                                    <template v-for="item in scope.row['work_order_label']">
                                        <el-tag type="warning" :key="item.id" style="margin-right: 4px">{{item.name}}</el-tag>
                                    </template>
                                    <template v-if="!scope.row['work_order_label']?.length">-</template>
                                    <i v-if="getCurAuth('work_order_label_edit')"  @click="handleTagEdit([scope.row])" class="el-icon-edit-outline"></i>
                                </div>
                            </div>
                            
                            <div v-else-if="column.id == 'material_status_num'">
                                <div v-if="scope.row['material_status_num'] == '-'">
                                    <span @dblclick="copyText(scope.row['material_status_num'])">{{
                                        scope.row['material_status_num'] }}</span>
                                </div>
                                <div v-else
                                    @dblclick="copyText(`(${scope.row['no_upload_material_num']}，${scope.row['no_audit_material_num']}，${scope.row['pass_material_num']})/${scope.row['material_num']}`)">
                                    <span style="color: #409EFF;cursor: pointer;"
                                        v-matomo="{ behaviorCategory: '素材工单(工单管理-制作中)', event: '点击', name: '列表(需求数量进入详情)' }"
                                        @click="handleInfo(scope.row, false)">({{ scope.row['no_upload_material_num']
                                        }}</span>，
                                    <span style="color: #f56c6c;cursor: pointer;"
                                        v-matomo="{ behaviorCategory: '素材工单(工单管理-制作中)', event: '点击', name: '列表(需求数量进入详情)' }"
                                        @click="handleInfo(scope.row, true, 'no_audit_list')">{{
                                        scope.row['no_audit_material_num'] }}</span>，
                                    <span style="color: rgb(103, 194, 58);cursor: pointer;padding-right: 5px;"
                                        v-matomo="{ behaviorCategory: '素材工单(工单管理-已完成)', event: '点击', name: '列表(需求数量进入详情)' }"
                                        @click="handleInfo(scope.row, true, 'pass_list')">{{
                                        scope.row['pass_material_num'] }})</span>/
                                    <span style="">{{ scope.row['material_num'] }}</span>
                                </div>
                            </div>
                            <div v-else-if="column.id == 'material_create_user'">
                                <div v-if="scope.row[column.id] && Array.isArray(scope.row[column.id])">
                                    <div v-for="(item, i) in scope.row[column.id]" :key="i" @dblclick="copyText(item)">
                                        {{ item }}</div>
                                </div>
                                <div v-else>-</div>
                            </div>
                            <div v-else-if="column.id == 'controls'">
                                <div v-if="tagsActive == 1">
                                    <el-button type="text" size="mini" v-if="getCurAuth('work_order_info')"
                                        :style="{ color: '#409EFF', marginLeft: 0, marginRight: '10px' }"
                                        v-matomo="{ behaviorCategory: '素材工单(工单管理-待指派)', event: '点击', name: '列表(查看)' }"
                                        @click="handleInfo(scope.row, false)">查看</el-button>
                                    <el-button type="text" size="mini" v-if="getCurAuth('work_order_copy')"
                                        :style="{ color: '#409EFF', marginLeft: 0, marginRight: '10px' }"
                                        v-matomo="{ behaviorCategory: '素材工单(工单管理-待指派)', event: '点击', name: '列表(复制)' }"
                                        @click="handleCopy(scope.row)">复制</el-button>
                                    <el-button type="text" size="mini" v-if="getCurAuth('withdraw_work_order')"
                                        :style="{ color: '#ff0000', marginLeft: 0 }"
                                        v-matomo="{ behaviorCategory: '素材工单(工单管理-待指派)', event: '点击', name: '列表(撤回)' }"
                                        @click="handleWithdraw(scope.row)">撤回</el-button>
                                </div>
                                <div v-else-if="tagsActive == 2">
                                    <el-button type="text" size="mini" v-if="getCurAuth('work_order_info')"
                                        :style="{ color: '#409EFF', marginLeft: 0, marginRight: '10px' }"
                                        v-matomo="{ behaviorCategory: '素材工单(工单管理-制作中)', event: '点击', name: '列表(查看)' }"
                                        @click="handleInfo(scope.row, false)">查看</el-button>
                                    <el-button type="text" size="mini" v-if="getCurAuth('download_material')"
                                        :class="{ 'disabledBtn': scope.row.is_disabled_download }"
                                        :style="{ color: '409EFF', marginLeft: 0, marginRight: '10px' }"
                                        :disabled="scope.row.is_disabled_download"
                                        v-matomo="{ behaviorCategory: '素材工单(工单管理-制作中)', event: '点击', name: '列表(下载素材)' }"
                                        @click="handleOnlyDown(scope.row)">下载素材</el-button>
                                    <el-button type="text" size="mini" v-if="getCurAuth('work_order_copy')"
                                        :style="{ color: '#409EFF', marginLeft: 0, marginRight: '10px' }"
                                        v-matomo="{ behaviorCategory: '素材工单(工单管理-制作中)', event: '点击', name: '列表(复制)' }"
                                        @click="handleCopy(scope.row)">复制</el-button>
                                    <el-button type="text" size="mini"
                                        :class="{ 'disabledBtn': scope.row.is_disabled_finish }"
                                        v-if="getCurAuth('completion_work_order')"
                                        :style="{ color: '#ff0000', marginLeft: 0 }"
                                        :disabled="scope.row.is_disabled_finish"
                                        v-matomo="{ behaviorCategory: '素材工单(工单管理-制作中)', event: '点击', name: '列表(结单)' }"
                                        @click="handleSettle(scope.row)">结单</el-button>
                                </div>
                                <div v-else-if="tagsActive == 3">
                                    <el-button type="text" size="mini" v-if="getCurAuth('work_order_info')"
                                        :style="{ color: '#409EFF', marginLeft: 0, marginRight: '10px' }"
                                        v-matomo="{ behaviorCategory: '素材工单(工单管理-被驳回)', event: '点击', name: '列表(查看)' }"
                                        @click="handleInfo(scope.row, false)">查看</el-button>
                                    <el-button type="text" size="mini" v-if="getCurAuth('edit_work_order')"
                                        :style="{ color: '#409EFF', marginLeft: 0, marginRight: '10px' }"
                                        v-matomo="{ behaviorCategory: '素材工单(工单管理-被驳回)', event: '点击', name: '列表(修改)' }"
                                        @click="handleEdit(scope.row)">修改</el-button>
                                    <el-button type="text" size="mini" v-if="getCurAuth('withdraw_work_order')"
                                        :style="{ color: '#ff0000', marginLeft: 0 }"
                                        v-matomo="{ behaviorCategory: '素材工单(工单管理-被驳回)', event: '点击', name: '列表(撤回)' }"
                                        @click="handleWithdraw(scope.row)">撤回</el-button>
                                </div>
                                <div v-else-if="tagsActive == 4">
                                    <el-button type="text" size="mini" v-if="getCurAuth('work_order_info')"
                                        :style="{ color: '#409EFF', marginLeft: 0, marginRight: '10px' }"
                                        v-matomo="{ behaviorCategory: '素材工单(工单管理-已完成)', event: '点击', name: '列表(查看)' }"
                                        @click="handleInfo(scope.row, false)">查看</el-button>
                                    <el-button type="text" size="mini"
                                        :style="{ color: '#409EFF', marginLeft: 0, marginRight: '10px' }"
                                        v-if="getCurAuth('download_material')"
                                        :class="{ 'disabledBtn': scope.row.is_disabled_download }"
                                        :disabled="scope.row.is_disabled_download"
                                        v-matomo="{ behaviorCategory: '素材工单(工单管理-已完成)', event: '点击', name: '列表(下载素材)' }"
                                        @click="handleOnlyDown(scope.row)">下载素材</el-button>
                                    <el-button type="text" size="mini" v-if="getCurAuth('work_order_copy')"
                                        :style="{ color: '#409EFF', marginLeft: 0 }"
                                        v-matomo="{ behaviorCategory: '素材工单(工单管理-已完成)', event: '点击', name: '列表(复制)' }"
                                        @click="handleCopy(scope.row)">复制</el-button>
                                </div>
                                <div v-else-if="tagsActive == 5">
                                    <el-button type="text" size="mini" v-if="getCurAuth('work_order_info')"
                                        :style="{ color: '#409EFF', marginLeft: 0, marginRight: '10px' }"
                                        v-matomo="{ behaviorCategory: '素材工单(工单管理-已撤回)', event: '点击', name: '列表(查看)' }"
                                        @click="handleInfo(scope.row, false)">查看</el-button>
                                    <el-button type="text" size="mini" v-if="getCurAuth('work_order_copy')"
                                        :style="{ color: '#409EFF', marginLeft: 0, marginRight: '10px' }"
                                        v-matomo="{ behaviorCategory: '素材工单(工单管理-已撤回)', event: '点击', name: '列表(复制)' }"
                                        @click="handleCopy(scope.row)">复制</el-button>
                                    <el-button type="text" size="mini" v-if="getCurAuth('edit_work_order')"
                                        :style="{ color: '#409EFF', marginLeft: 0 }"
                                        v-matomo="{ behaviorCategory: '素材工单(工单管理-已撤回)', event: '点击', name: '列表(修改)' }"
                                        @click="handleEdit(scope.row)">修改</el-button>
                                </div>
                                <div v-else-if="tagsActive == 6">
                                    <el-button type="text" size="mini" v-if="getCurAuth('work_order_info')"
                                               :style="{color: '#409EFF', marginLeft: 0,marginRight: '10px'}"
                                               v-matomo="{behaviorCategory: '素材工单(工单管理-待结单)', event: '点击',  name: '列表(查看)' }"
                                               @click="handleInfo(scope.row, false)">查看</el-button>
                                    <el-button type="text" size="mini" v-if="getCurAuth('work_order_copy')"
                                               :style="{color: '#409EFF', marginLeft: 0,marginRight: '10px'}"
                                               v-matomo="{behaviorCategory: '素材工单(工单管理-待结单)', event: '点击',  name: '列表(复制)' }"
                                               @click="handleCopy(scope.row)">复制</el-button>
                                    <el-button type="text" size="mini" v-if="getCurAuth('download_material')"
                                               :class="{'disabledBtn': scope.row.is_disabled_download}"
                                               :style="{color: '409EFF', marginLeft: 0,marginRight: '10px'}"
                                               :disabled="scope.row.is_disabled_download"
                                               v-matomo="{behaviorCategory: '素材工单(工单管理-待结单)', event: '点击',  name: '列表(下载素材)' }"
                                               @click="handleOnlyDown(scope.row)">下载素材</el-button>
                                    <el-button type="text" size="mini"
                                               :class="{'disabledBtn': scope.row.is_disabled_finish}"
                                               v-if="getCurAuth('completion_work_order')"
                                               :style="{color: '#ff0000', marginLeft: 0}"
                                               :disabled="scope.row.is_disabled_finish"
                                               v-matomo="{behaviorCategory: '素材工单(工单管理-待结单)', event: '点击',  name: '列表(结单)' }"
                                               @click="handleSettle(scope.row)">结单</el-button>
                                </div>

                            </div>
                            <div v-else-if="column.id=='company_name'||column.id=='bloc_name'">
                                <div v-if="scope.row[column.id] && Array.isArray(scope.row[column.id])" @dblclick="copyText((scope.row[column.id]||[]).join('；'))">{{(scope.row[column.id]||[]).join('；')||'-'}}</div>
                                <span v-else @dblclick="copyText(scope.row[column.id])">{{scope.row[column.id]||'-'}}</span>
                            </div>
                            <div v-else-if="column.id=='product_names'" class="work-order-products">
                                <template v-if="scope.row.product_list && scope.row.product_list.length">
                                    <div v-for="product in scope.row.product_list"
                                         :key="`${product.product_source}:${product.product_plat_id}:${product.product_key}`"
                                         class="work-order-product">
                                        <div class="product-name" :title="product.product_name || '-'">{{product.product_name || '-'}}</div>
                                        <div class="product-details">
                                            <span class="product-meta" :title="`${product.product_plat_name || '-'}｜ID ${product.display_id || product.product_key}`">{{product.product_plat_name || '-'}}｜ID {{product.display_id || product.product_key}}</span>
                                            <span v-if="product.subproject_content" class="product-package"
                                                  :title="`包名：${product.subproject_content}`">包名 {{product.subproject_content}}</span>
                                        </div>
                                    </div>
                                </template>
                                <span v-else>-</span>
                            </div>
                            <div v-else-if="column.id=='detail_info'">
                                <div v-if="scope.row[column.id] && Array.isArray(scope.row[column.id])">
                                    <el-tooltip effect="dark" placement="top">
                                        <div @dblclick="copyTextArr(scope.row[column.id])">
                                            <div v-for="(item, i) in scope.row[column.id]" :key="i" class="mb2 mt2 ellipsis">
                                                <span>{{ item.info }}-</span>
                                                <span :class="[item.urgent_level=='加急'?'text-color-error':'']">{{item.urgent_level}}-{{item.expected_end_time}}</span>
                                            </div>
                                        </div>
                                        <div slot="content">
                                            <div v-for="(item, i) in scope.row[column.id]" :key="i" @dblclick="copyText([item.info,item.urgent_level,item.urgent_level].join('-'))" class="mb2 mt2 ellipsis">
                                                <span>{{ item.info }}-</span>
                                                <span :class="[item.urgent_level=='加急'?'text-color-error':'']">{{item.urgent_level}}-{{item.expected_end_time}}</span>
                                            </div>
                                        </div>
                                    </el-tooltip>
                                </div>
                                <span v-else>{{scope.row[column.id]||'-'}}</span>
                            </div>
                            <div v-else @dblclick="copyText(scope.row[column.id])">
                                <HoverEllipsisTips :text="scope.row[column.id]" />
                            </div>
                        </template>
                    </el-table-column>
                </jt-table>
                <PageBar :isTop="false">
                    <div class="tar pt20 pr40 pb20 bg-white">
                        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                            :current-page="currentPage" :page-sizes="[30, 50, 100]" :page-size="pageSize"
                            layout="total, sizes, prev, pager, next, jumper" :total="total">
                        </el-pagination>
                    </div>
                </PageBar>
                
            </div>
        </div>
    </div>
</template>

<script>

import Query from './query.vue'
import ObliqueTags from '../../../components/obliqueTags.vue'
import MaterialExtendItem from '../../../components/materialExtendItem.vue'
import { fieldTableModal } from "@/views/workOrder/modal";
import PageBar from '@/components/PageBar'
import {
    withdrawModal,
    downLoadModal,
    settleModel,
    rejectModal,
    resultModal,
    filterNullDownModal,
    tagEditModal
} from '../modalMaterial'
import API from "@/api/workOrder/material.js"
import { uniqBy, find } from "lodash";
import matomoFun from "@/utils/matomo.js";
import { mapState, mapActions, mapMutations } from "vuex";
import HoverEllipsisTips from "@/views/workOrder/components/hoverEllipsis.vue";
import {setStorage, getStorage, removeStorage} from '@/utils/index.js';
export default {
    name: 'MaterialPage',
    props: {
        reload: {
            type: String,
            default: ''
        },
        pageFuncNames: Array,
        query: {
            type: Object,
            default: function () {
                return {}
            }
        },
        formatDateColor: Function,
    },
    components: {
        HoverEllipsisTips,
        Query,
        ObliqueTags,
        MaterialExtendItem,
        PageBar
    },
    data() {
        return {
            tableData: [],
            multipleSelection: [],
            tags: [
                {
                    value: '1',
                    label: '待指派'
                }, {
                    value: '2',
                    label: '制作中'
                }, {
                    value: '6',
                    label: '待结单'
                }, {
                    value: '3',
                    label: '被驳回'
                }, {
                    value: '4',
                    label: '已完成'
                }, {
                    value: '5',
                    label: '已撤回'
                }
            ],
            tagsActive: '1',
            value: '1',
            queryData: {},
            currentPage: 1,
            pageSize: 30,
            pageNum: 1,
            total: 0,
            loading: false,
            exportLoading: false,
            columns: [],
            modalList: [],
            selectList: [],
            sortList: ['order_id', 'material_num', 'expected_end_time', 'ctime', 'delete_time'], //排序字段  前端指定, 'rejected_time', 'delete_time'
            curKey: 0,
            activated_once: 1,
            tableHeight: 'auto',
            getLocalStorageWidth: {},
        }
    },
    computed: {
        ...mapState({
            uploadQueue: state => state.workOrder.workTaskList,
        })
    },
    watch: {
        'query': {
            handler(n, o) {
                const { tagsActive } = n
                this.tagsActive = tagsActive ? tagsActive.toString() : '1'
            },
            deep: true,
            immediate: true
        },
        'tagsActive': {
            handler(val) {
                let name_list = this.tags.filter(item => item.value == val)
                let cur_name = '待指派'
                if (name_list && name_list.length !== 0) {
                    cur_name = name_list[0].label
                }
                this.CHANGE_BREADCRUMB(['工单管理', cur_name])
            },
            immediate: true
        },
    },
    created() {
        this.getLocalStorageWidth = getStorage('localStorage', 'materialTableWidthMap') || {}
    },
    mounted() {
        this.CLEAR_ROUTE_CACHE()
        // 监听窗口大小变化
        window.addEventListener('resize', this.calculateTableHeight)
    },
    activated() {
        let name_list = this.tags.filter(item => item.value == this.tagsActive)
        let cur_name = '待指派'
        if (name_list && name_list.length !== 0) {
            cur_name = name_list[0].label
        }
        this.CHANGE_BREADCRUMB(['工单管理', cur_name])
        this.$nextTick(() => {
            this.$refs.refs_table.doLayout()
            if (this.activated_once !== 1 && !this.reload) {
                let res_params = { ...this.queryData, order_status: this.tagsActive, fields: this.selectList, pn: this.currentPage, rn: this.pageSize }
                this.fetchGetList(res_params)
            }
        })
    },
    beforeDestroy() {
        // 移除窗口大小变化监听
        window.removeEventListener('resize', this.calculateTableHeight)
    },
    methods: {
        ...mapActions('workOrder', [
            'ADD_ROUTE_LIST',
            'CLEAR_ROUTE_CACHE'
        ]),
        ...mapMutations('app', [
            'CHANGE_BREADCRUMB',
        ]),
        handleTagEdit(list) {
            if(list.length == 0) {
                return this.$message.warning('请选择工单后操作');
            };
            const onSubmit = (data) => {
                this.handleCurrentChange(this.currentPage)
                vm.close()
            }
            const { vm } = tagEditModal({
                props: {
                    selectList: list,
                    type: 'work_order',
                },
                cbs: {
                   onSubmit
                }
            })
        },
        // 操作权限
        getCurAuth(name) {
            return this.pageFuncNames.includes(name);
        },
        fetchGetCustomField(params) {
            this.loading = true
            API.getCustomField({ field_type: 'work_order', sub_type: this.tagsActive }).then(res => {
                let result = res.data
                let user_field = result.user_field
                this.modalList = result.field ? result.field : []
                this.selectList = user_field
                let uni_fixed_data = []
                let uni_drag_data = []

                let reduce_list = this.modalList.reduce((prev, cur) => {
                    if (cur?.children.length > 0) {
                        prev.push(...cur.children);
                        return prev
                    }
                }, [])
                for (const item of user_field) {
                    reduce_list.forEach((el) => {
                        if (el.checked) {
                            if (!!el['config']) {
                                let toObjectConfig = JSON.parse(el['config'])
                                if (item == el['id']) {
                                    if (toObjectConfig['fixed']) {
                                        uni_fixed_data.push({
                                            id: el['id'],
                                            width: 160,
                                            display_name: el["display_name"],
                                            fixed: toObjectConfig['fixed'],
                                        })
                                    } else {
                                        uni_drag_data.push({
                                            id: el['id'],
                                            width: 160,
                                            display_name: el["display_name"],
                                            fixed: null,
                                        })
                                    }
                                }
                            } else {
                                if (item == el['id']) {
                                    uni_drag_data.push({
                                        id: el['id'],
                                        width: 120,
                                        display_name: el["display_name"],
                                        fixed: null,
                                        disabled: null
                                    })
                                }
                            }
                        }
                    })
                }

                let fixedData = uniqBy(uni_fixed_data, 'id')
                let dragData = uniqBy(uni_drag_data, 'id')
                this.columns = [...fixedData, ...dragData].map(item => {
                    if (item.id == 'material_status_num') {
                        item['width'] = 250
                    } else if (item.id == 'product_names') {
                        item['width'] = 280
                    }
                    return item
                })
                this.$nextTick(() => {
                    // 确保表格重新计算布局
                    this.$refs.refs_table.doLayout();
                });
                this.fetchGetList({ ...params, fields: this.selectList })
            }, err => {
                this.loading = false
                this.$message.error(err.info)
            })
        },
        fetchSetCustomField(values) {
            API.editCustomField({ field_type: 'work_order', fields: values, sub_type: this.tagsActive }).then(res => {
                let res_params = { ...this.queryData, order_status: this.tagsActive, pn: this.currentPage, rn: this.pageSize }
                this.fetchGetCustomField(res_params)
            }, err => {
                this.$message.error(err.info)
            })
        },
        fetchGetList(params) {
            this.loading = true
            API.postWorkOrderGetList(params).then((res) => {
                if (!params.export) {
                    this.tableData = res?.data?.list ? res.data.list : []
                    this.total = res.data.totalCnt
                    this.tags = [
                        {
                            value: '1',
                            label: '待指派',
                            num: res.data.no_audit_num ? res.data.no_audit_num : 0
                        }, {
                            value: '2',
                            label: '制作中',
                            num: res.data.in_production_num ? res.data.in_production_num : 0
                        }, {
                            value: '6',
                            label: '待结单',
                            num: res.data.no_finish_num ? res.data.no_finish_num : 0
                        }, {
                            value: '3',
                            label: '被驳回',
                            num: res.data.rejected_num ? res.data.rejected_num : 0
                        }, {
                            value: '4',
                            label: '已完成',
                            num: res.data.pass_num ? res.data.pass_num : 0
                        }, {
                            value: '5',
                            label: '已撤回',
                            num: res.data.withdraw_num ? res.data.withdraw_num : 0
                        }
                    ]
                    this.loading = false

                    this.$refs.refs_table.$forceUpdate()
                    this.calculateTableHeight()
                } else {
                    // 导出的情况
                    this.exportLoading = false
                    this.loading = false
                    this.$message.success(res.info)
                }
                this.curKey++
            }, err => {
                this.loading = false
                this.exportLoading = false
                this.$message.error(err.info)
            })
        },
        // 排序
        handlesortchange({ column, prop, order }) {
            // ascending 升   descending 降
            let order_type = order == 'ascending' ? 'asc' : 'desc'
            this.queryData['order_fields'] = prop
            this.queryData['order'] = order_type
            let res_params = { ...this.queryData, order_status: this.tagsActive, fields: this.selectList, pn: this.currentPage, rn: this.pageSize }
            this.loading = true
            this.fetchGetList(res_params)
        },
        // 排序显示
        getsortable(value) {
            if (this.sortList.includes(value) || ((this.tagsActive == '2' || this.tagsActive == '4') && value == 'material_end_time') || ((this.tagsActive == '3' || this.tagsActive == '5') && value == 'rejected_time') || ((this.tagsActive == '4') && value == 'finish_time')) {
                return 'custom'
            } else {
                return false
            }

        },
        // 折角矩形 标签点击
        handleTabClick(val) {
            this.$refs.refs_table.clearSort()
            this.columns = []
            this.tableData = []
            this.queryData['order_fields'] = ''
            this.queryData['order'] = ''
            let res_params = { ...this.queryData, order_status: val, pn: this.currentPage, rn: this.pageSize, material_group: [] }
            this.loading = true
            this.fetchGetCustomField(res_params)

            this.$router.replace({
                name: 'work_order_material',
                query: {
                    topage: 'MaterialPage',
                    tagsActive: val ? val.toString() : '1',
                },
                params: {
                    menuReload: 1
                }
            });

            // let res_params = {...this.queryData,order_status:val,fields: this.selectList, pn:this.currentPage,rn:this.pageSize}
            // this.fetchGetList(res_params)
        },
        pushMatomo(name) {
            let cur_name = find(this.tags, item => item.value == this.tagsActive)
            let behaviorCategory = `素材工单(工单管理-${cur_name?.label})`
            matomoFun.trackEvent(behaviorCategory, '点击', name)
        },
        handleFieldTable() {
            this.pushMatomo('自定义列')
            const { vm } = fieldTableModal(
                {
                    props: {
                        customClass: 'custom-indicator-new apple-custom-indicator',
                        customList: this.modalList,
                        selectList: this.selectList
                    },
                    cbs: {
                        onSubmit: (data) => {
                            this.tableData = []
                            this.fetchSetCustomField(data)
                            vm.close()
                        },
                        onClose: () => {
                            vm.close()
                        }
                    }
                }
            )
        },
        handleUpdata(data) {
            this.queryData = data
        },
        // 查询结果
        handleQueryClick(params) {
            this.queryData = params.params
            if (params.reload && (params.reload === 'add' || params.reload === 'copy')) {
                this.currentPage = 1
                this.tagsActive = '1'
                this.$refs.refs_table.clearSort()
                this.queryData['order_fields'] = ''
                this.queryData['order'] = ''
            }
            if (params.status) {
                this.tagsActive = this.queryData.msg_type
                this.$refs.refs_table.clearSort()
                this.queryData['order_fields'] = ''
                this.queryData['order'] = ''
                let res_params = { ...this.queryData, order_status: this.tagsActive, pn: 1, rn: this.pageSize }
                this.fetchGetCustomField(res_params)
                return
            }
            let res_params = { ...this.queryData, order_status: this.tagsActive, pn: this.currentPage, rn: this.pageSize }
            this.fetchGetCustomField(res_params)
        },
        // 每页条数
        handleSizeChange(val) {
            this.pageSize = val
            let res_params = { ...this.queryData, order_status: this.tagsActive, fields: this.selectList, pn: this.currentPage, rn: this.pageSize }
            this.fetchGetList(res_params)
        },
        // 当前页数
        handleCurrentChange(val) {
            this.currentPage = val
            let res_params = { ...this.queryData, order_status: this.tagsActive, fields: this.selectList, pn: this.currentPage, rn: this.pageSize }
            this.fetchGetList(res_params)
        },
        // 消息的点击跳转
        handleMsg(type) {
            this.tagsActive = type
            let res_params = { ...this.queryData, order_status: type, pn: 1, rn: this.pageSize }
            this.fetchGetCustomField(res_params)
        },
        // 导出
        async exportData() {
            try {
                this.pushMatomo('导出')
                this.exportLoading = true
                let res_params = { ...this.queryData, order_status: this.tagsActive, fields: this.selectList, pn: this.currentPage, rn: this.pageSize, export: '1' }
                await this.fetchGetList(res_params)
                // await this.getList()
            } catch (error) { } finally {
                this.exportLoading = false
            }
        },
        /**
         * show_type  展开详情的方式 true 全部展开  false
         * show_status  展开详情的状态
         * */
        handleInfo(rows, show_type, show_status) {
            if (!this.getCurAuth('work_order_info')) {
                this.$message.warning('您没有权限')
                return
            }
            // if(show_status) {
            //     this.$emit('changePage','MaterialInfoPage',{order_id:rows.order_id, tagsActive:this.tagsActive, show_type:show_type, show_status:show_status});
            // }else{
            //     this.$emit('changePage','MaterialInfoPage',{order_id:rows.order_id, tagsActive:this.tagsActive, show_type:show_type});
            // }
            this.ADD_ROUTE_LIST(
                this.query
            )
            this.$router.push({
                name: 'work_order_material',
                query: {
                    formpage: 'MaterialPage',
                    topage: 'MaterialInfoPage',
                    id: rows.order_id,
                    tagsActive: this.tagsActive ? this.tagsActive.toString() : '1',
                    show_type: show_type ? show_type : false,
                    show_status: show_status ? show_status : ''
                },
                params: {
                    menuReload: 1
                }
            });
            this.activated_once++
        },
        handleSelectionChange(val) {
            this.multipleSelection = val;
        },
        // 禁止选中
        checkSelect(row) {
            return !row.is_disabled_download
        },
        // 批量剔除
        handleFilterDown() {
            if (this.multipleSelection.length == 0) {
                return this.$message.warning('请选择工单后操作')
            }
            let noList = this.multipleSelection.filter(item => item.is_disabled_download&&this.isSelectable(item))
            if (noList.length != 0) {
                const { vm } = filterNullDownModal(
                    {
                        props: {
                            list: noList,
                        },
                        cbs: {
                            onSubmit: (data) => {
                                vm.close()
                                setTimeout(() => {
                                    this.handleGroupDown()
                                }, 300)
                            },
                        }
                    }
                )
            } else {
                this.handleGroupDown()
            }

        },
        // 批量下载
        handleGroupDown() {
            let noList = this.multipleSelection.filter(item => !item.is_disabled_download)
            let order_ids = noList.map(item => item['order_id'])
            if (!order_ids || order_ids.length == 0) {
                return this.$message.warning('剔除后没有可下载的工单，请重新选择')
            }

            if (order_ids.length > 30) {
                return this.$message.warning('批量下载一次最多只能同时下载30个工单素材')
            }

            const { vm } = downLoadModal(
                {
                    props: {
                        // id:group_ids,
                        title: '批量下载',
                        tagsActive: this.tagsActive ? this.tagsActive.toString() : '1',
                        orderId: order_ids,
                    },
                    cbs: {
                        onSubmit: (data) => {
                            this.$refs.refs_table.clearSelection();
                            this.multipleSelection = []
                            vm.close()
                        },
                    }
                }
            )
        },
        // 单独下载
        handleOnlyDown(rows) {
            const { vm } = downLoadModal(
                {
                    props: {
                        // id:group_ids,
                        title: '下载素材',
                        tagsActive: this.tagsActive ? this.tagsActive.toString() : '1',
                        orderId: [rows.order_id],
                    },
                    cbs: {
                        onSubmit: (data) => {
                            vm.close()
                        },
                    }
                }
            )
        },
        // 结单 弹框
        handleSettle(rows) {
            let isEqul = this.uploadQueue.some(item => item.order_id == rows.order_id)
            if (isEqul) {
                return this.$message.warning('该任务正再上传素材，无法继续操作，素材上传完成后可继续操作')
            }
            const { vm } = settleModel(
                {
                    props: {
                        id: rows.order_id
                    },
                    cbs: {
                        onSubmit: (data) => {
                            vm.close()
                            let res_params = { ...this.queryData, order_status: this.tagsActive, fields: this.selectList, pn: this.currentPage, rn: this.pageSize }
                            this.fetchGetList(res_params)
                        }
                    },
                    on: {
                        close: () => {
                            vm.close()
                            this.pushMatomo('列表(结算-取消)')
                        }
                    }
                }
            )
        },
        // 批量结单 弹框
        batchSettle(){
            if(this.multipleSelection.length == 0) {
                return this.$message.warning('请选择工单后操作');
            }
            let actionRows = this.multipleSelection.filter(item=>{
                if(item.is_disabled_finish) return false;
                if(this.uploadQueue.some(task=>task.order_id == item.order_id)) return false;
                if(!this.isSelectable(item)) {
                    return false
                }
                return true;
            })
            if (actionRows.length == 0) {
                return this.$message.warning('剔除后无可结单的工单，请重新选择');
            }
            console.log('batchSettle-actionRows',actionRows);
            let orderIds = actionRows.map(item=>item.order_id).join(',');
            let cur_name = find(this.tags, item=>item.value == this.tagsActive);
            let behaviorCategory = `素材工单(工单管理-${cur_name?.label})`;
            const { vm } = settleModel(
                {
                    props: {
                        id: orderIds,
                        name: behaviorCategory,
                    },
                    cbs:{
                        onSubmit:(data)=>{
                            vm.close();
                            let res_params = {...this.queryData,order_status:this.tagsActive,fields: this.selectList, pn:this.currentPage,rn:this.pageSize};
                            this.fetchGetList(res_params)
                        }
                    },
                    on:{
                        close:()=>{
                            vm.close();
                            this.pushMatomo('列表(批量结单-取消)')
                        }
                    }
                }
            )

        },
        // 撤回 弹框
        handleWithdraw(rows) {
            const { vm } = withdrawModal(
                {
                    props: {
                        id: rows.order_id,
                        tagsActive: this.tagsActive ? this.tagsActive.toString() : '1'
                    },
                    cbs: {
                        onSubmit: (data) => {
                            vm.close()
                            this.pushMatomo('撤回(提交)')
                            let res_params = { ...this.queryData, order_status: this.tagsActive, fields: this.selectList, pn: this.currentPage, rn: this.pageSize }
                            this.fetchGetList(res_params)
                        },
                    }
                }
            )
        },
        handleEdit(row) {
            // console.log('handleEdit',row);
            // this.$emit('changePage','createPage',{...row, work_order_create_type: 'edit',fromPage: 'MaterialPage', tagsActive:this.tagsActive});
            this.handleToPage(row, 'edit')
        },
        handleCopy(row) {
            // this.$emit('changePage','createPage',{...row, work_order_create_type: 'copy',fromPage: 'MaterialPage', tagsActive:this.tagsActive});
            this.handleToPage(row, 'copy')

        },
        toCreatePage() {
            // console.log('toCreatePage');
            // this.$emit('changePage','createPage',{work_order_create_type: 'add',fromPage: 'MaterialPage', tagsActive:this.tagsActive});
            this.handleToPage({}, 'add')
        },
        handleToPage(row, type) {
            this.ADD_ROUTE_LIST(
                this.query
            )
            this.$router.push({
                name: 'work_order_material',
                query: {
                    formpage: 'MaterialPage',
                    topage: 'CreatePage',
                    order_id: type === 'add' ? '' : row.order_id,
                    tagsActive: this.tagsActive ? this.tagsActive.toString() : '1',
                    actionType: type
                },
                params: {
                    menuReload: 1
                }
            });
            this.activated_once++
        },
        copyText(text) {
            if (!text || text === '-') return
            const textarea = document.createElement('textarea');
            textarea.value = text;
            document.body.appendChild(textarea);
            textarea.select();
            document.execCommand('copy');
            document.body.removeChild(textarea);
            this.$message.success('复制成功');
        },
        copyTextArr(arr) {
            if (!arr || arr.length == 0) return
            const text = arr.map(item => `${item.info}-${item.urgent_level}-${item.expected_end_time}`).join('；')
            this.copyText(text)
        },
        // 计算表格最大高度
        calculateTableHeight() {
            const height = window.innerHeight ||
                document.documentElement.clientHeight ||
                document.body.clientHeight;
            let tableContainerHeight = 0
            this.$nextTick(() => {
                // 获取容器元素
                const container = this.$el.querySelector('.el-table__body')
                if (container) {
                    // 计算容器高度减去头部和底部区域
                    tableContainerHeight = container.offsetHeight
                } else {
                    tableContainerHeight = 0
                }
                if (tableContainerHeight >= height - 200) {
                    this.tableHeight = 'calc(100vh - 120px)'
                } else {
                    this.tableHeight = 'auto'
                }
            })
        },
        handleDragEnd(newWidth, oldWidth, column) {
            let getCurrentNameWidth = this.getLocalStorageWidth || {}
            //存储示例格式 {address: 707, date: 184, name: 246}
            let result = Object.assign(getCurrentNameWidth, {
                [column.property]: parseInt(newWidth),
            });
            setStorage('localStorage', 'materialTableWidthMap', Object.assign({},this.getLocalStorageWidth,result));
        },
        isSelectable(row){
            if(this.tagsActive == 2){
                // 制作中，需求数量==未上传数量 不可选择
                if(row.material_num>0&&row.material_num==row.no_upload_material_num){
                    return false;
                }
                return true;
            }
            return true;

        },
    }
}
</script>
<style lang="scss" scoped>
@import "~@/styles/material_sd.scss";

.disabledBtn {
    cursor: no-drop;
    color: #dadada !important;
}
.work-order-product + .work-order-product { margin-top: 6px; }
.work-order-products .product-name,
.work-order-products .product-meta,
.work-order-products .product-package { overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
.work-order-products .product-details { display: flex; min-width: 0; color: #909399; font-size: 12px; }
.work-order-products .product-meta { flex-shrink: 0; max-width: 55%; }
.work-order-products .product-package { min-width: 0; margin-left: 8px; }
</style>
<style>
.custom-indicator-new {
    min-width: 900px;
}
</style>
<style scoped lang="scss">
.tab-box {
    i {
        display: none;
        cursor: pointer;
        color: rgb(64, 158, 255);
    }
    &:hover {
        i {
            display: inline;
        }
    }
}
</style>
